import { createContext, useContext } from "react";

/** Come si mostrano tabella e schede del preventivo. Di base: la pagina dell'operatore, coi comandi; la pagina mette i file del suo
 *  preventivo (l'indirizzo del file vuole l'id del preventivo). La copia ferma per l'amministratore (spec § 8) le mostra in sola lettura, coi file del suo link;
 *  `fileUrl` null = quella bolletta non ha il file nella copia, il mese resta senza link. */
export interface Modo {
  solaLettura: boolean;
  fileUrl: (bollettaId: string) => string | null;
}

export const ModoPreventivo = createContext<Modo>({ solaLettura: false, fileUrl: () => null });

export function useModo(): Modo {
  return useContext(ModoPreventivo);
}
